import { ReactElement } from 'react'
import { Chip, Typography } from '@mui/material'
import type { UserOrganisationDTO } from '@api/fastAPI.schemas'
import { Box } from '@ui/structure'
import { organisationLabel } from '@utils'

interface Props {
  organisations: UserOrganisationDTO[]
}

const UserOrganisations = ({ organisations }: Props): ReactElement => {
  if (organisations.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Keine Organisation
      </Typography>
    )
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={0.5}>
      {organisations.map(organisation => (
        <Chip
          key={organisation.guid}
          size="small"
          label={
            organisation.is_admin
              ? `${organisationLabel(organisation)} (Admin)`
              : organisationLabel(organisation)
          }
          color={organisation.is_admin ? 'primary' : 'default'}
          variant={organisation.is_admin ? 'filled' : 'outlined'}
        />
      ))}
    </Box>
  )
}

export default UserOrganisations
